import { render } from "./FeatureButton.vue?vue&type=template&id=9aec9152"
import script from "./FeatureButton.vue?vue&type=script&lang=js"
export * from "./FeatureButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__